var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left"},[_c('h3',[_vm._v("Notes")]),_c('TextEditor',{staticClass:"pt-1",attrs:{"value":_vm.notes,"hasOwnState":""},on:{"input":function (notes) { return _vm.$emit('updateCharacter', { notes: notes }); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }